import { ReactNode } from 'react'
import './ControlField.css'

type Props = {
  label: string
  children: ReactNode
}

const ControlField = ({ label, children }: Props) =>
  <label className="control-field">
    <div>{label}</div>
    <div className="control-field__control">{children}</div>
  </label>

export default ControlField
